import LeaveRightsReportComponent from "features/Report/components/leaveRightsGroup/LeaveRightsReport";
import useLeaveRightsReport from "features/Report/hooks/leaveRightsGroup/useLeaveRightsReport";

const LeaveRightsPage = () => {
    const LeaveRightsReportProps = useLeaveRightsReport();
    return <LeaveRightsReportComponent {...LeaveRightsReportProps} />;
};

export default LeaveRightsPage;